import { Tooltip } from "@mui/material"
import { InfoOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import { INVENTORY_PALLET_LOT_STATUS_TO_LABEL, PALLET_HOLD_TOOLTIP } from "../../constants"
import { getInventoryLotKey } from "../../utils"

import type { InventoryByPalletItemLot } from "@/graphql/codegen/graphql"
import { InventoryLotStatus } from "@/graphql/codegen/graphql"
import { InventoryLotStack } from "@/screens/Inventory/components/InventoryLotStack"

interface ProductInventoryPalletStatusStackProps {
  lots: InventoryByPalletItemLot[] | null | undefined
}

export const ProductInventoryPalletStatusStack: FC<ProductInventoryPalletStatusStackProps> = ({ lots }) => (
  <InventoryLotStack
    lots={lots}
    getKey={getInventoryLotKey}
    render={(lot) => (
      <span className='flex flex-wrap items-center gap-x-2'>
        {lot.inventoryStatuses.map((status) => (
          <span key={status} className='flex items-center gap-x-1 whitespace-nowrap'>
            {INVENTORY_PALLET_LOT_STATUS_TO_LABEL[status]}
            {status === InventoryLotStatus.PalletHold && (
              <Tooltip title={PALLET_HOLD_TOOLTIP} placement='top'>
                <InfoOutlined
                  fontSize='small'
                  className='text-gray-600'
                  data-testid='product-inventory-pallet.status-stack.pallet-hold-info-icon'
                />
              </Tooltip>
            )}
          </span>
        ))}
      </span>
    )}
  />
)
